const actions =  {
    HANDLE_CHANGE: 'HANDLE_CHANGE',
    HANDLE_MENU: 'HANDLE_MENU',
}

export default actions;